import { CustomerType } from "@origin-digital/platform-enums";
import {
  BasicJSONSchema,
  CommonParameters,
  IMcAppType,
  NavFlow,
  Tab,
} from "../mcApp.types";

const { accountNumbers } = CommonParameters;

const journeyType = {
  description:
    "Indicates the specific user journey or flow for setting up payment settings, used to differentiate between various setup scenarios.",
  type: "string",
} as BasicJSONSchema;

export const paymentSettingsSetUp: IMcAppType = {
  name: "paymentSettingsSetUp",
  path: "/my/payment-settings/setup",
  parameters: {
    properties: { accountNumbers, journeyType },
  },
  description: "Setup direct debit for a set of given accounts numbers",
  navFlow: NavFlow.FOCUS,
  title: "Set up direct debit",
  parent: Tab.DASHBOARD, // Changed from Tab.MORE, Temporary workaround due to navigation issues on Mobile. See https://origindd.atlassian.net/browse/P21-2410

  conditions: {
    intent: "paymentSettingsSetUp",
    customerType: CustomerType.kraken,
  },
};
